export const MEMBERSHIP_PACKAGE_KIND = {
  BUSINESS: 'Business',
  CLUB_PLATINUM: 'ClubPlatinum',
  BLACK_PARTNER: 'BlackPartner',
  DIAMOND_PARTNER: 'DiamondPartner',
} as const
